import {
  GET_INITIAL_EXPENSE_ITEMS,
  GET_EXPENSE_ITEMS,
  UPDATE_EXPENSE_ITEMS_LIST
} from "@core/store/action-constants";
import {
  UPDATE_EXPENSE_ITEMS_FILTERS,
  UPDATE_EXPENSE_ITEMS_LIST_PAGINATION
} from "@core/store/mutation-constants";
import { RootState } from "@core/store/root-state";
import {
  PartialExpenseItemsListState,
  ExpenseItemsListResponse
} from "@core/store/types/common/lists/ExpenseItemsListState";
import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { ExpenseItemsListService } from "@core/services/common/lists/ExpenseItemsListService";
import { ExposeItem } from "@core/store/modules/admin/finances/modules/financeHistory/expenseItems";

const initialState = (): PartialExpenseItemsListState => {
  return {
    data: {},
    filters: {
      id: null,
      name: null
    },
    pagination: {
      page: 1,
      perPage: 20
    }
  };
};

const state: () => PartialExpenseItemsListState = initialState;

const getters: GetterTree<PartialExpenseItemsListState, RootState> = {};

const mutations: MutationTree<PartialExpenseItemsListState> = {
  SET_EMPTY: state => Object.assign(state, initialState()),

  [UPDATE_EXPENSE_ITEMS_LIST] (state, expenseItems: ExpenseItemsListResponse["expenseItems"]) {
    if (state.pagination.page !== 1 && state.data?.items && expenseItems) {
      state.data.items = Array.from(new Set([...state.data.items, ...expenseItems.items as []]));
    } else {
      state.data = expenseItems;
    }
  },

  [UPDATE_EXPENSE_ITEMS_LIST_PAGINATION] (state) {
    if (state.data?.items && state.data.items.length >= state.pagination.perPage) {
      state.pagination.page = Math.ceil(state.data.items.length / state.pagination.perPage) + 1;
    }
  },

  [UPDATE_EXPENSE_ITEMS_FILTERS] (state, filters: PartialExpenseItemsListState["filters"]) {
    if (filters?.name !== state.filters?.name) {
      state.pagination.page = 1;
    }
    state.filters = { ...state.filters, ...filters };
  }
};

const actions: ActionTree<PartialExpenseItemsListState, RootState> = {
  async [GET_EXPENSE_ITEMS] ({ commit, state }) {
    const limit = state.pagination.perPage;
    const offset = state.filters?.name ? 0 : (state.pagination.page - 1) * limit;
    const { data: { expenseItems } } =
      await ExpenseItemsListService.getExpenseItems(state.filters, limit, offset);
    commit(UPDATE_EXPENSE_ITEMS_LIST, expenseItems);
    return expenseItems;
  },

  async [GET_INITIAL_EXPENSE_ITEMS] ({ commit, state }, ids) {
    if (ids) {
      ids = Array.isArray(ids) ? ids : [ids];
    }
    const { data: { expenseItems, initialExpenseItems } } = await ExpenseItemsListService.getExpenseItems(
      state.filters,
      state.pagination.perPage,
      0,
      { id: ids });
    expenseItems.items = [...initialExpenseItems.items, ...expenseItems.items as []];

    commit(UPDATE_EXPENSE_ITEMS_LIST, expenseItems);
    return initialExpenseItems?.items?.length ? initialExpenseItems.items.map((item: ExposeItem) => item.id) : null;
  }
};

export const expenseItemsList: Module<PartialExpenseItemsListState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
